import { render, staticRenderFns } from "./TierMenu.vue?vue&type=template&id=cd3f2c04&scoped=true&"
import script from "./TierMenu.vue?vue&type=script&lang=js&"
export * from "./TierMenu.vue?vue&type=script&lang=js&"
import style0 from "./TierMenu.vue?vue&type=style&index=0&id=cd3f2c04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd3f2c04",
  null
  
)

export default component.exports